import CyaHelper from "../utils/CyaHelper";

export class ImageModel {
    imageId = 0;
    hash = "";
    filename = "";
    fileContent = "";
    imageGuid = CyaHelper.Guid();
}